export default "__VITE_ASSET__D0Zlo06o__"